module.exports = __webpack_public_path__ + "static/media/33cankstreet.cfa4db3b.jpg";